module.exports = __webpack_public_path__ + "img/logo.2534f247.png";